import { Feature } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Polygon from 'ol/geom/Polygon';
import Style from 'ol/style/Style';
import { Fill } from 'ol/style';
import { LAYER_TYPE } from '@/components/Map/MapViewer/MapViewer.constants';

/**
 * Wraps the map-card {@link VectorSource} in a fresh {@link VectorLayer} so each
 * map can render the shared source with its own layer object.
 */
export const createCardLayer = (
  source: VectorSource<Feature<Polygon>>,
): VectorLayer<VectorSource<Feature<Polygon>>> => {
  const vectorLayer = new VectorLayer({
    // eslint-disable-next-line no-magic-numbers
    zIndex: -Infinity,
    source,
    style: new Style({
      fill: new Fill({
        color: '#fff',
      }),
    }),
  });
  vectorLayer.set('type', LAYER_TYPE.MAP_CARD_LAYER);
  return vectorLayer;
};
